export default "__VITE_ASSET__2267b172__"